import React from 'react'
import { InfoButton } from 'components/buttons'

const NoRegItemsMessage = ({
  clearFilters,
  totalRegItemsCount,
  filteredRegItemsCount,
}) => {
  let msg

  if (totalRegItemsCount == 0) {
    msg = `This registry doesn't have any gifts yet.`
  } else if (filteredRegItemsCount == 0) {
    msg = 'No gifts matched the filters you selected.'
  }

  return (
    <React.Fragment>
      {msg && (
        <div className="well flex col center paxl" style={{ minHeight: 300 }}>
          <span className="text-center">{msg}</span>
          {clearFilters && totalRegItemsCount != 0 && (
            <InfoButton
              className="mtm"
              onClick={clearFilters}
              empty
              pill
              size="small"
            >
              Clear Filters
            </InfoButton>
          )}
        </div>
      )}
    </React.Fragment>
  )
}

export default NoRegItemsMessage
